// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay_overlay__4y-yR","hidden":"overlay_hidden__3QJP0"};